export default "__VITE_ASSET__B65rpsUA__"